(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/shared/assets/javascripts/image-sizes.js') >= 0) return;  svs.modules.push('/components/content/shared/assets/javascripts/image-sizes.js');
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function () {
  'use strict';

  var isServer = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object';

  var MARGIN = 12;
  var LIMIT_XS = 480;
  var LIMIT_CONTENT = 1357;
  var MEDIA_QUERIES = {
    md: "(min-width: ".concat(LIMIT_XS, "px)"),
    lg: "(min-width: ".concat(LIMIT_CONTENT, "px)")
  };

  var ENUM = {
    xs_no_margin: '100vw',
    xs: "calc(100vw - ".concat(MARGIN * 2, "px)"),
    md_6col: "".concat(MEDIA_QUERIES.md, " calc((100vw - ").concat(MARGIN * 3, "px)/2)"),
    md_8col: "".concat(MEDIA_QUERIES.md, " calc((100vw - ").concat(MARGIN * 3, "px)/12*8)"),
    lg: "".concat(MEDIA_QUERIES.lg, " ").concat(LIMIT_CONTENT, "px"),
    lg_6col: "".concat(MEDIA_QUERIES.lg, " ").concat((LIMIT_CONTENT - MARGIN * 3) / 2, "px"),
    lg_8col: "".concat(MEDIA_QUERIES.lg, " ").concat((LIMIT_CONTENT - MARGIN * 3) / 12 * 8, "px"),
    wide: "100vw"
  };

  function getMediaQuery(sizes) {
    return sizes.join(', ');
  }

  function getMediaQueryForColumn(columnIndex, columns) {
    var fullWidthSizes = [ENUM.lg, ENUM.xs];
    var columnWidthSizes = [ENUM.lg_6col, ENUM.md_6col, ENUM.xs];
    var isLastPosAndOdd = columnIndex === columns.length - 1 && (columnIndex + 1) % 2 === 1;
    return getMediaQuery(isLastPosAndOdd ? fullWidthSizes : columnWidthSizes);
  }

  if (isServer) {
    module.exports = {
      ENUM: ENUM,
      MEDIA_QUERIES: MEDIA_QUERIES,
      getMediaQuery: getMediaQuery,
      getMediaQueryForColumn: getMediaQueryForColumn
    };
  } else {
    svs.content.shared.imageSizes = {
      ENUM: ENUM,
      MEDIA_QUERIES: MEDIA_QUERIES,
      getMediaQuery: getMediaQuery,
      getMediaQueryForColumn: getMediaQueryForColumn
    };
  }
})();

 })(window);